<template>
<div id="" class="pb100">


  <v-card-title class="secondary white--text">
    <v-col cols="2">
      <v-icon dark>fa-gift</v-icon>
    </v-col>
    <v-col cols="8" class="text-center">
      <h3>Contests</h3>
    </v-col>
    <v-col cols="2" class="text-right">
      <v-btn icon dark @click="$eventBus.$emit('play_video',$store.state.app.tutorials.contests['General'])">
        <v-icon>fa-question</v-icon>
      </v-btn>
    </v-col>
  </v-card-title>

  <v-container fluid class="secondary lighten-1 white--text py-0">
    <v-row justify="center">
      <v-col cols="10" md="4" lg="3" xl="2">
        <v-text-field dark outlined hide-details label="Search" v-model="$store.state.contests.search" clearable></v-text-field>
      </v-col>

      <v-col cols="10" md="4" lg="3" xl="2">
        <v-select dark outlined label="Show" placeholder="All" :items="$store.state.contests.filter_options" clearable :value="$store.state.contests.filter" @change="$store.commit('contests/update_filter',$event)" hide-details></v-select>
      </v-col>
      <v-col cols="10" md="4" lg="3" xl="2">
        <v-select dark outlined label="Sort by" placeholder="Featured" :items="$store.state.contests.sort_options" clearable :value="$store.state.contests.sort" @change="$store.commit('contests/update_sort',$event)" hide-details></v-select>
      </v-col>
    </v-row>
  </v-container>


  <v-container fluid>
    <v-row v-if="$store.getters['contests/list'].length">
      <v-col cols="12" sm="6" md="4" lg="4" xl="3" v-for="(contest,i) in $store.getters['contests/list']" :key="i">


        <v-hover v-slot:default="{ hover }">
          <router-link class="nolink" :to="`/contests/${contest.id}/${contest.slug}`">
            <v-card :elevation="hover ? 12 : 2">

              <v-card-actions class="secondary  white--text">
                <h5><v-icon class="mr-2" small :color="contest.status===1 ? 'green' : 'red' " dark>fa-circle</v-icon> {{contest.status===1 ? 'Open' : contest.status===1 ? 'Closed' : 'Completed'}}</h5>
                <v-spacer></v-spacer>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                        <v-btn icon small v-on="on" @click="$store.getters['account/isLoggedIn'] ?  $store.dispatch('account/toggle_bookmark',contest.id) : loginRequired() ">
                          <v-icon small v-if="contest.bookmarked" color="orange">fas fa-bookmark</v-icon>
                          <v-icon small v-else  color="orange">far fa-bookmark</v-icon>
                        </v-btn>
                      </template>
                  <span v-if="contest.bookmarked">Bookmarked</span>
                  <span v-else>Bookmark</span>
                </v-tooltip>
              </v-card-actions>


              <div class="contest-box" :style="`background-image:url(${contest.promo_poster})`">
                <v-overlay :absolute="true" :value="true" :opacity="0.6" v-if="contest.status!==1" style="z-index:1">
                  <v-icon x-large color="">fa-lock</v-icon>
                </v-overlay>
              </div>


              <v-card-actions class="secondary white--text">
                <v-spacer></v-spacer>
                <router-link class="nolink white--text" :to="`/contests/${contest.id}/${contest.slug}`">
                  <h5>{{contest.title}}</h5>
                </router-link>
                <v-spacer></v-spacer>
              </v-card-actions>

              <v-container>
                <v-row align="center" justify="space-around">
                  <v-col cols="3" md="3">
                    <div class="contest-brand-logo" :style="`background-image:url(${contest.brand_logo})`">
                    </div>
                  </v-col>
                  <v-col cols="8" md="7" class="py-0">
                    <v-container class="py-0 px-0">
                      <v-row>
                        <v-col cols="12">
                          <h3 class="secondary--text">Rank requirement
                        <span :class="`ml-2 rank-star rank-${contest.min_rank}-star`">
                          <v-icon  style="margin-top:-4px" >fa fa-star</v-icon>
                        </span>
                      </h3>
                          <p class="">
                            {{contest.min_rank > 1 ? 'Open to rank ' +contest.min_rank + ' and up' : 'Open to all ranks' }}
                          </p>
                        </v-col>
                        <v-col cols="12">
                          <h3 class="secondary--text">Prize</h3>
                          <p class="">
                            {{contest.prize}}
                          </p>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </router-link>
        </v-hover>

      </v-col>
    </v-row>
    <v-row v-else class="py-4">
      <v-col cols="12" class="text-center" style="padding-top:100px">
        <v-icon style="font-size:65px" class="mb-4 growing" color="cool_purple">fa-gift</v-icon>
        <h3>New contests coming soon!</h3>
      </v-col>
    </v-row>

  </v-container>
</div>
</template>
<script>
export default {
  name: "",
  data: () => ({

  }),
  created() {
    this.$store.dispatch('contests/load')
  },
  methods: {
    loginRequired() {
      this.$router.push({
        path: '/login',
        query: {
          continue: '/contests'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.contest-brand-logo {
    width: 100%;
    height: 150px;
    background-size: contain;
    background-position: center;
}

.contest-box {
    width: 100%;
    height: 270px;
    background-size: contain;
    background-position: center;
    position: relative;
}

.growing {
    animation: grow 0.75s;
    animation-delay: 0s;
    animation-timing-function: ease-in;
    animation-iteration-count: infinite;
}
@keyframes grow {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);

    }
    100% {
        transform: scale(1);
    }
}
</style>
